import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/systemview')({
  component: () => <Outlet />,
  staticData: {
    title: 'System View',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
